import React, { useState } from 'react';
import LocationDisplay from './LocationDisplay';

interface MoveObjetModalProps {
  objet: any;
  isOpen: boolean;
  onClose: () => void;
  onMove: (objetId: string, newZoneId: string, newBoxId: string) => void;
}

const MoveObjetModal: React.FC<MoveObjetModalProps> = ({ objet, isOpen, onClose, onMove }) => {
  const [newZoneId, setNewZoneId] = useState('');
  const [newBoxId, setNewBoxId] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (newZoneId || newBoxId) {
      onMove(objet.id, newZoneId, newBoxId);
      onClose();
    }
  };

  if (!isOpen || !objet) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          Déplacer l'objet
        </h3>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            <strong>Objet:</strong> {objet.nom}
          </p>
          <p className="text-sm text-gray-600">
            <strong>Localisation actuelle:</strong> {objet.zoneId ? `Zone ${objet.zoneId}` : objet.boxId ? `Box ${objet.boxId}` : 'Non localisé'}
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Nouvelle localisation
            </label>
            <LocationDisplay
              objet={{ zoneId: newZoneId, boxId: newBoxId }}
              isEditable={true}
              onLocationChange={(zoneId, boxId) => {
                setNewZoneId(zoneId);
                setNewBoxId(boxId);
              }}
            />
          </div>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 bg-gray-200 rounded-md hover:bg-gray-300 transition-colors"
            >
              Annuler
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Déplacer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MoveObjetModal;
